export const LEASE_DEFAULT_PAGE_SIZE = 12;
// The My Leases endpoint is paginated server-side but has no search/status filters,
// so the full list is fetched once and filtered/paged on the client.
export const LEASE_FETCH_PAGE_SIZE = 500;

export const LEASE_ENDPOINTS = {
  // Leases of the logged-in customer (owner resolved from the auth token)
  listMy: "/lease/leases",
  create: "/lease/add",
  edit: "/lease/edit",
  updateStatus: "/lease/status",
  remove: (id) => `/lease/delete/${id}`,
  details: (id) => `/lease/${id}`,

  // Lease notes
  notes: "/lease/notes",
  addNote: "/lease/note/add",
  editNote: "/lease/note/edit",
  removeNote: (id) => `/lease/note/delete/${id}`,

  // Helper endpoints
  purposes: "/lease-purpose/all",
  states: (countryId = 1) => `/admin/states/${countryId}`,
  cities: (stateId) => `/admin/cities/${stateId}`,
};

// Mirrors the backend LeaseStatus enum (com.all.homedesire.enums.LeaseStatus)
export const LEASE_STATUSES = [
  { value: "PENDING", label: "Pending", variant: "warning" },
  { value: "IN_REVIEW", label: "In Review", variant: "info" },
  { value: "INPROGRESS", label: "In Progress", variant: "primary" },
  { value: "COMPLETED", label: "Completed", variant: "success" },
  { value: "PAYOUT_DONE", label: "Payout Done", variant: "dark" },
];

export const LEASE_DEFAULT_STATUS = "PENDING";
